module.exports = __webpack_public_path__ + "static/img/14000011.ab5ed8d8.png";